import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import moment from "moment";
import { logo } from "../../../constant";
import { paymentMethods } from "../../../data";
import {
  formatNumberWithCommas,
  formatPhone,
  formattedDate,
} from "../../../helpers";
import { getUserPendingAmount, getUserTotalAmount } from "../../../lib/users";
const getStatusLabel = (statusId) => {
  switch (statusId) {
    case 1:
      return "Confirmed";
    case 2:
      return "Cancelled";
    case 3:
      return "Pending";
    case 4:
      return "Completed";
    default:
      return "--";
  }
};
const derivedStatus = (data) => {
  if (data === 1) {
    return "Received";
  } else if (data === 2) {
    return "Refunded";
  }
};

export const exportUserDetailToPDF = (userDetail) => {
  // Get primary player details
  const primaryPlayer = userDetail?.bookingPlayers?.find(
    (player) => player?.isPrimary
  );

  // Create a style element for our CSS classes
  const styleElement = document.createElement("style");
  styleElement.textContent = `
      .pdf-container {
        width: 210mm;
        padding: 20px;
        font-family: Arial, sans-serif;
        position: absolute;
        left: -9999px;
      }
      .logo-section {
        text-align: center;
        margin-bottom: 20px;
      }
      .logo-image {
        width: 190px;
        height: 40px;
      }
      .reference-section {
        margin-bottom: 20px;
      }
      .reference-title {
        color: var(--highlight-text);
        font-size: 20px;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 14px;
        margin-top: 10px;
      }
      .details-section {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width:840px;
        gap: 10px;
        margin-bottom: 20px;
        font-size: 12px;
      }
        .detail-list-wrapper{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 10px;
        width: 200mm;
        
        box-sizing: border-box;
      }
       
        .detail-list-wrapper li{
      
       width: calc(50% - 10px);
        margin-bottom: 8px;
      }
      .detail-item {
        margin: 0;

        
        line-height: 20px;
        letter-spacing: -0.25px;
        display: flex;
        align-items: center;
       
        font-family: "NotoSans-semibold";
        font-size: 16px;
        margin-bottom: 10px;
      }
         .detail-item strong{
         
        color: var(--highlight-text);
        font-weight: 600;
        line-height: 20px;
        letter-spacing: -0.25px;
        font-family: "NotoSans-semibold";
        display: inline-block;
        min-width: 80px;
      }
        .detail-item span{
        color: var(--dusky-steel);
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.25px;
        font-family: "NotoSans-regular";
        display: inline-block;
        min-width: 80px;
        }
      .divider {
        border: none;
        border-top: 1px solid #ccc;
        margin: 20px 0;
      }
      .section-title {
        font-size: 16px;
        font-weight: 600;
        color: var(--highlight-text);
        margin-bottom: 10px;
      }
      .data-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 9px;
        margin-bottom: 20px;
      }
      .table-header {
        // background-color: #3A86DD;
        background-color: transparent;
        color: var(--highlight-text);
        font-weight: 600;
        font-size: 14px;
        

      }
       thead  .table-cell {
        padding: 8px;
        text-align: left;
        
        border-bottom: 1px solid #9EA2B3;
        border-top: 1px solid #9EA2B3;
        font-size: 13px;
        font-weight: 600;
        color: var(--highlight-text);
      }
     tbody .table-cell {
        padding: 8px;
        text-align: left;
        
        
        font-size: 14px;
        font-weight: 400;
        color: var(--dusky-steel);
      }
      .empty-row {
        text-align: center;
        padding: 8px;
      }
      .status-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 10px;
  max-width: 88px;
  border: 1px solid var(--cloudy-silver);
  border-radius: 6px;
}
.title {
  color: var(--text-color);
  font-size: 12px;
  line-height: 18px;
  font-family: "NotoSans-medium";
}
.ball {
  display: flex;
   width: 6px;
  height: 6px;
}

.active {
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--green-color);
}

.inactive {
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #4e4354;
}
  .group-info{
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 3px;
 
  }

   .group-info span:first-child{
    display: block;
    font-size: 13px;
    line-height: 20px;
    font-family: "NotoSans-regular";
    color: var(--dusky-steel);
   }
  .group-info span:last-child{
    display: block;
    font-size: 13px;
    line-height: 20px;
    font-family: "NotoSans-regular";
    color: var(--dusky-steel);
   }
    .longText strong{
  width:165px;

    }
    `;
  document.head.appendChild(styleElement);

  // Create an HTML container for our content
  const container = document.createElement("div");
  container.className = "pdf-container";
  document.body.appendChild(container);

  // Create HTML content with classes
  const content = `
      <div class="logo-section">
        <img class="logo-image" src="${logo}" alt="Logo">
      </div>
      
    
      
      <div class="details-section">
      <ul class="detail-list-wrapper">
      
      <li>
       <p class="detail-item"><strong>Name:</strong> <span> ${
         userDetail?.userFullName || "--"
       }</span></p>
        <p class="detail-item"><strong>Phone:</strong> <span> ${
          formatPhone(userDetail?.cellNumber) || "--"
        }</span></p>
        <p class="detail-item"><strong>Email:</strong><span>${
          userDetail?.email || "--"
        }</span> </p>
        <p class="detail-item"><strong>Status:</strong> <span> ${
          userDetail?.active ? "Active" : "Inactive"
        }</span></p>
       
       
       
      </li>
 <li>

  
        <p class="detail-item longText"><strong>Collected Amount: </strong> <span > ${
          formatNumberWithCommas(getUserTotalAmount(userDetail?.bookings)) ||
          "--"
        }</span></p>
        <p class="detail-item longText"><strong>Pending Amount:</strong> <span > ${formatNumberWithCommas(
          getUserPendingAmount(userDetail?.bookings) || 0
        )}</span></p>   
         <p class="detail-item longText"><strong>Total Bookings:</strong> <span > ${
           userDetail?.bookings?.length || "--"
         }</span></p>
 </li>
      </ul>
       
      </div>
      
      ${
        userDetail?.payments?.length > 0
          ? `
          <hr class="divider">
          
          <div>
            <h2 class="section-title">Payment Details</h2>
          </div>
          
          <div>
            <table class="data-table">
              <thead>
                <tr class="table-header">
                  <th class="table-cell">Payment ID</th>
                   <th class="table-cell">Reference ID</th>
                     <th class="table-cell">Location</th>
                  <th class="table-cell">Date</th>
                  <th class="table-cell">Amount</th>
                  <th class="table-cell">Payment Mode</th>
                  <th class="table-cell">Payment Status</th>
                 
                </tr>
              </thead>
              <tbody>
                ${userDetail?.payments
                  ?.map(
                    (payment) => `
                  <tr>
                    <td class="table-cell">
                      ${payment?.payNo?.split("-")?.slice(1).join("-")}
                    </td>
                     <td class="table-cell">
                      ${payment?.bookingNo?.split("-")?.slice(1).join("-")}
                    </td>
                     <td class="table-cell">
                    ${payment?.locationName || "--"}
                    </td>
                    <td class="table-cell">


  <div class="group-info">
                 <span>
                 ${formattedDate(payment?.paymentDate)}
                 </span>
                 <span>
                    ${moment(payment?.paymentDate, "HH:mm:ss").format(
                      "hh:mm A"
                    )} 
                 </span>
                 </div>         
                    </td>
                    <td class="table-cell">
                      Rs. ${formatNumberWithCommas(payment?.amount)}
                    </td>
                    <td class="table-cell">
                      ${
                        paymentMethods?.find(
                          (item) => item?.value === payment?.paymentModeId
                        )?.label || "--"
                      }
                    </td>
                    <td class="table-cell">
                      ${derivedStatus(payment?.paymentStatusId)}
                    </td>
                  </tr>
                `
                  )
                  .join("")}
              </tbody>
            </table>
          </div>
        `
          : "" // Don't render anything if there are no payments
      }
      
      <div>
        <h2 class="section-title">Bookings</h2>
      </div>
      
      <div>
        <table class="data-table">
          <thead>
            <tr class="table-header">
              <th class="table-cell">
              Reference ID</th>
              <th class="table-cell">Court Name</th>
              <th class="table-cell">Amount</th>
              <th class="table-cell">Date & Time</th>
              
              <th class="table-cell">Payment Status</th>
               <th class="table-cell">Booking Status</th>
            </tr>
          </thead>
          <tbody>
            ${
              userDetail?.bookings
                ?.map(
                  (booking) => `
              <tr>
              <td class="table-cell">
               ${booking?.bookingNo?.split("-")?.slice(1).join("-")}
              </td>
                <td class="table-cell">
                  ${booking?.courtName || "--"}
                </td>
                 <td class="table-cell">

                 <div class="group-info">
                 <span>
                 Total: ${formatNumberWithCommas(booking?.bookingGrossAmount)}
                 </span>
                 <span>
                 Collected: ${formatNumberWithCommas(
                   booking?.bookingCollectedAmount
                 )}
                 </span>
                 </div>
               
                </td>
                <td class="table-cell">
                 <div class="group-info">
                 <span>
                 ${formattedDate(booking?.bookingDate)}
                 </span>
                 <span>
                    ${moment(booking?.bookingStartTime, "HH:mm:ss").format(
                      "hh:mm A"
                    )} - 
                  ${moment(booking?.bookingEndTime, "HH:mm:ss").format(
                    "hh:mm A"
                  )}
                 </span>
                 </div>
               
                </td>
                
                <td class="table-cell">
                  ${derivedStatus(booking?.bookingStatusId)}
                </td>
                  <td class="table-cell">
                  ${getStatusLabel(booking?.bookingStatusId)}
                </td>
              </tr>
            `
                )
                .join("") ||
              `<tr><td class="empty-row" colspan="2">No slot details available</td></tr>`
            }
          </tbody>
        </table>
      </div>
    `;

  // Set the innerHTML of the container
  container.innerHTML = content;

  // Function to handle PDF generation after HTML is rendered
  const generatePDF = async () => {
    try {
      // Use html2canvas to convert the HTML to canvas
      const canvas = await html2canvas(container, {
        scale: 2, // Higher scale for better quality
        useCORS: true, // Enable CORS for images
        logging: false,
      });

      // Create PDF
      const pdf = new jsPDF("p", "mm", "a4");
      const imgData = canvas.toDataURL("image/png");

      // Calculate the proper scaling
      const imgWidth = 210; // A4 width in mm minus margins
      const pageHeight = 297; // A4 height in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      // Add first page
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Add more pages if content is longer than one page
      while (heightLeft > 0) {
        position = -pageHeight * (imgHeight / heightLeft);
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      // Save the PDF
      pdf.save(
        `booking_details_${userDetail?.bookingNo
          ?.split("-")
          ?.slice(1)
          .join("-")}.pdf`
      );

      // Clean up
      document.body.removeChild(container);
      document.head.removeChild(styleElement);
    } catch (error) {
      console.error("Error generating PDF:", error);
      document.body.removeChild(container);
      document.head.removeChild(styleElement);
    }
  };

  // Generate the PDF
  generatePDF();
};
